/* eslint-disable no-tabs */
import React from 'react';
import { PayPalMessages } from '@paypal/react-paypal-js';

export function PaypalMessage(orderTotal) {
  const msgStyle = {
    layout: 'text',
    logo: {
      type: 'inline'
    },
    text: {
      color: 'black'
    }
  };

  return (
    <PayPalMessages
      style={msgStyle}
      amount={orderTotal}
      forceReRender={[orderTotal]}
    />
  );
}